import { PropsWithChildren } from 'react';
import { useRootSelector } from '../../../../../store/hooks';
import { selectBrandHubLayout } from '../../store/features/layout';
import Layout, { LayoutProps } from '../Layout';

export default function StaticPageLayout(
  props: Omit<PropsWithChildren<LayoutProps>, 'layout'>,
) {
  const { data: layout } = useRootSelector(selectBrandHubLayout);

  return <Layout {...props} layout={layout} />;
}
